import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import AppModule from "./app/app.module";
import { CacheNamesEnum, TokenTypesEnum } from "./app/models/shared.model";


Office.onReady((info: any) => {
  if (info.host === Office.HostType.Outlook) {
    const currentTokenType = JSON.parse(window.localStorage.getItem(CacheNamesEnum.TOKEN_TYPE));

    // IF user logged-in using the fallback way, clear the TokenType cache to try to log-in using NAA
    if(currentTokenType != null && currentTokenType == TokenTypesEnum.OFFICE_GET_CALLBACK_TOKEN)
      window.localStorage.setItem(CacheNamesEnum.TOKEN_TYPE, JSON.stringify(-1))

    platformBrowserDynamic().bootstrapModule(AppModule);
  }
});
